"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M35.075 7.493a13.944 13.944 0 0 1-4.006 1.1 7 7 0 0 0 3.067-3.859 13.968 13.968 0 0 1-4.429 1.693 6.982 6.982 0 0 0-11.887 6.36A19.8 19.8 0 0 1 3.442 5.5 6.983 6.983 0 0 0 5.6 14.812a6.945 6.945 0 0 1-3.159-.873v.088a6.98 6.98 0 0 0 5.6 6.84 7 7 0 0 1-3.15.12 6.982 6.982 0 0 0 6.509 4.844 14 14 0 0 1-8.663 2.986 14.193 14.193 0 0 1-1.664-.1 19.744 19.744 0 0 0 10.693 3.134c12.831 0 19.847-10.629 19.847-19.847q0-.454-.02-.9a14.176 14.176 0 0 0 3.482-3.611z" })
);

